import { HttpClientModule } from '@angular/common/http'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgChartsModule } from 'ng2-charts'
import { DndModule } from 'ngx-drag-drop'
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BarChartComponent } from './data-visualization/charts/bar-chart/bar-chart.component'
import { IframeComponent } from './data-visualization/charts/iframe/iframe.component'
import { PieChartComponent } from './data-visualization/charts/pie-chart/pie-chart.component'
import { ScatterPlotComponent } from './data-visualization/charts/scatter-plot/scatter-plot.component'
import { StackedBarComponent } from './data-visualization/charts/stacked-bar/stacked-bar.component'
import { SunburstComponent } from './data-visualization/charts/sunburst/sunburst.component'
import { WorldMapComponent } from './data-visualization/charts/world-map/world-map.component'
import { AggregationWidgetComponent } from './data-visualization/components/aggregation-widget/aggregation-widget.component'
import { AggregationWrapperComponent } from './data-visualization/components/aggregation-wrapper/aggregation-wrapper.component'
import { Error404Component } from './errors/error404/error404.component'
import { AboutComponent } from './pages/about/about.component'
import { ComparatorComponent } from './pages/comparator/comparator.component'
import { HomeComponent } from './pages/home/home.component'
import { FilterLoaderComponent } from './pages/incentive-database/filter-loader.component'
import { IncentiveDatabaseComponent } from './pages/incentive-database/incentive-database.component'
import { IncentiveLoaderComponent } from './pages/incentive-database/incentive-loader.component'
import { indicatorsLoaderComponent } from './pages/indicators/indicators-loader.component'
import { IndicatorsComponent } from './pages/indicators/indicators.component'
import { BreadcrumbComponent } from './partials/breadcrumb/breadcrumb.component'
import { CartComponent } from './partials/cart/cart.component'
import { CountryComparisonWidgetComponent } from './partials/country-comparison-widget/country-comparison-widget.component'
import { FavoriteButtonComponent } from './partials/favorite-button/favorite-button.component'
import { FlashMessageComponent } from './partials/flash-message/flash-message.component'
import { FooterComponent } from './partials/footer/footer.component'
import { HeaderCountriesLoaderComponent } from './partials/header/header-countries-loader.component'
import { HeaderComponent } from './partials/header/header.component'
import { MultiSelectInputComponent } from './partials/multi-select-input/multi-select-input.component'
import { CountryDetailLoaderComponent } from './resources/country/country-detail/country-detail-loader.component'
import { CountryDetailComponent } from './resources/country/country-detail/country-detail.component'
import { CountryListComponent } from './resources/country/country-list/country-list.component'
import { IncentiveComparatorLoaderComponent } from './resources/incentive/incentive-comparator/incentive-comparator-loader.component'
import { IncentiveComparatorComponent } from './resources/incentive/incentive-comparator/incentive-comparator.component'
import { IncentiveDetailComponent } from './resources/incentive/incentive-detail/incentive-detail.component'
import { OrderIncentivesModalComponent } from './resources/incentive/order-incentive-modal/order-incentives-modal.component'
import { TruncatePipe } from './shared/pipes/truncate.pipe'
import { EnvironmentService } from './shared/services/environment.service';
import { AggregationTableComponent } from './data-visualization/charts/aggregation-table/aggregation-table.component';
import { PieChartLegendComponent } from './data-visualization/charts/pie-chart/pie-chart-legend/pie-chart-legend.component';
import { ClickOutsideDirective } from './shared/click-outside.directive'

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    HeaderCountriesLoaderComponent,
    FavoriteButtonComponent,
    HomeComponent,
    ComparatorComponent,
    IncentiveDatabaseComponent,
    CountryListComponent,
    CountryDetailComponent,
    CountryDetailLoaderComponent,
    CountryComparisonWidgetComponent,
    IncentiveDetailComponent,
    IncentiveComparatorComponent,
    IncentiveComparatorLoaderComponent,
    FilterLoaderComponent,
    IncentiveLoaderComponent,
    indicatorsLoaderComponent,
    BreadcrumbComponent,
    FlashMessageComponent,
    AggregationWrapperComponent,

    // Pipes.
    TruncatePipe,
    MultiSelectInputComponent,
    CartComponent,
    SunburstComponent,
    WorldMapComponent,
    StackedBarComponent,
    OrderIncentivesModalComponent,
    AboutComponent,
    Error404Component,
    IndicatorsComponent,
    PieChartComponent,
    IframeComponent,
    BarChartComponent,
    AggregationWidgetComponent,
    ScatterPlotComponent,
    AggregationTableComponent,
    PieChartLegendComponent,
    ClickOutsideDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgChartsModule,
    DndModule,
    GuidedTourModule,
    FormsModule
  ],
  providers: [
    GuidedTourService,
    {
      provide: APP_INITIALIZER,
      useFactory: (environmentService: EnvironmentService) => () =>
        environmentService.loadEnvironment().toPromise(),
      deps: [EnvironmentService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
